// extracted by mini-css-extract-plugin
module.exports = {"Sidedrawer":"Sidedrawer_Sidedrawer__3uVYt"};